import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_contract_lines_by_billingContractIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { billingContractId: number }): 
  Promise<{ result: { Id?: number, LineNumber?: number, Details?: { BillingContractLineId?: number, StrategyFieldName?: string }[], BillingRates?: { Id?: number }[], BillingTasks?: { Id?: number }[], BillingContract?: { Id?: number, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractId)) {
      missingRequiredInParams.push('\'billingContractId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_contract_lines_by_billingContractId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { billingContractId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LineNumber?: number, Details?: { BillingContractLineId?: number, StrategyFieldName?: string }[], BillingRates?: { Id?: number }[], BillingTasks?: { Id?: number }[], BillingContract?: { Id?: number, StatusId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractId)) {
      missingRequiredInParams.push('\'billingContractId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_contract_lines_by_billingContractId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { billingContractId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LineNumber?: number, Details?: { BillingContractLineId?: number, StrategyFieldName?: string }[], BillingRates?: { Id?: number }[], BillingTasks?: { Id?: number }[], BillingContract?: { Id?: number, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractId)) {
      missingRequiredInParams.push('\'billingContractId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_contract_lines_by_billingContractId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      billingContractId: number    }) {
        if(isNil(inParams.billingContractId)) {
          return true; 
        }
      return false;
    }
}
